import React, { useEffect, useState } from "react";
import PointSpreadLoading from "react-loadingg/lib/PointSpreadLoading";
import { Link } from "react-router-dom";
import { getSupermarketsOfferList } from "../../Api/BarestServices";
import { getSearchSuperyProductApi } from "../../Api/ClientServices";
import Grouping from "../../Component/Grouping/Grouping";
import NewDiscount from "../NewDiscount/NewDiscount";
import Style from "./SupermarketCategoryPart.module.css";
import { errorToast } from "../../Toast/Toast";

const SupermarketCategoryPart = (props) => {
  const [offerList, setOfferList] = useState();
  const [showSearchPart, setShowSearchPart] = useState();
  const [searchInput, setSearchInput] = useState("");
  const [searchValue, setSearchValue] = useState(false);
  useEffect(() => {
    getSuperMarketDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getSuperMarketDetail = async () => {
    getSupermarketsOfferList(props.supId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setOfferList(res.products);
        }
      }else{
        console.error(res)
      }
    })
  };
  ////////////// get search result /////////////
  const getSearchProduct = async (value) => {
    getSearchSuperyProductApi(value, props.supId,(succ,res)=>{
      if(succ){
        if(res.status===0){
          setShowSearchPart(false);
        }else{
          setShowSearchPart(true);
          setSearchValue(res.product);
        }
      }else{
        console.error(res)
      }
    });
    setSearchInput(value);
  };
  return (
    <div>
      {offerList === undefined ? (
        <div className={Style.loading2Test}>
          <PointSpreadLoading color={"#ab0c59"} size={"small"} />
        </div>
      ) : (
        <>
          <div className={Style.searchHolder}>
            <input
              className={Style.search}
              placeholder={"جستجو..."}
              onChange={(e) => getSearchProduct(e.target.value)}
              type={"text"}
            />
            {searchInput.length === 0 || !showSearchPart ? null : (
              <ul className={Style.searchResult}>
                {searchValue&&searchValue.map((item, index) => {
                  return (
                    <Link
                      to={{
                        pathname: `/product/${item.id}/${item.supplier_id}`,
                        state: item.id,
                      }}
                      className={Style.resultItem}
                      key={index}
                    >
                      <div className={Style.imgHolder}>
                        <img
                          src={`https://cdn.barest.ir/product/m/${item.id}.jpg`}
                          alt="محصولات"
                        />
                      </div>
                      <div className={Style.productInfo}>
                        <h3 className={Style.productName}>{item.name}</h3>
                        {/* <h3 className={Style.supplierName}>
                          <FontAwesomeIcon
                            icon={faShoppingBag}
                            className={Style.shopIcon}
                          />
                          {item.supplier_name}
                        </h3> */}
                        <div className={Style.priceHolder}>
                          {item.off_price === "0" ? null : (
                            <h3 className={Style.offPrice}>
                              {item.off_price}تومان
                            </h3>
                          )}
                          {item.off_price === "0" ? (
                            <h3 className={Style.price}>{item.price}تومان</h3>
                          ) : (
                            <h3 className={Style.ofprice}>{item.price}تومان</h3>
                          )}
                        </div>
                      </div>
                    </Link>
                  );
                })}
                <div className={Style.opacityPart}></div>
              </ul>
            )}
          </div>
          {offerList.length > 0?
          <div className={Style.discount}>
            <br />
            <div className={Style.discountTitle}>
              <h2 className={Style.rightTitle}>تخفیف دار</h2>
              <Link
                to={{ pathname: "/seemore", state: props.supId }}
                className={Style.leftTitle}
              >
                دیدن همه
              </Link>
            </div> 
            <br />
            {offerList === undefined ? (
              <div className={Style.loading2Test}>
                <PointSpreadLoading color={"#ab0c59"} size={"small"} />
              </div>
            ) : (
              <NewDiscount data={offerList} suplierId={props.supId} />
            )}
          </div>
           : null}
          <div className={Style.category}>
            <h2 className={Style.name}>دسته بندی</h2>
            <Grouping data={props.categoryList} supId={props.supId} />
          </div>
        </>
      )}
    </div>
  );
};
export default SupermarketCategoryPart;
